import { render, staticRenderFns } from "./PacientesEsperaConsulta.vue?vue&type=template&id=3af8f13f&"
import script from "./PacientesEsperaConsulta.vue?vue&type=script&lang=js&"
export * from "./PacientesEsperaConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports